(() => {
  angular
    .module('gm.common.router', [])
    .factory('GmyRouter', GmyRouter);

  function GmyRouter(
    $location,
    $window,
  ) {
    'ngInject';

    return {
      goToSignIn,
      isSignIn,
      path,
    };

    function goToSignIn(param) {
      if (!isSignIn()) {
        $window.location.href = `/sign-in${((!angular.isUndefined(param)
          && (angular.isString(param)) && (param.length > 0)) ? `/${param}` : '')}`;
      }
    }

    function isSignIn() {
      return $location.path().match('^/sign-in') || $location.path().match('^/forgot-password');
    }

    function path(origDestPath, replace = false) {
      const current = $location.path();

      let destPath;
      if (origDestPath === '/') {
        destPath = '/vault/overview';
      } else if (!origDestPath) {
        destPath = current;
      } else {
        destPath = origDestPath;
      }
      $location.path(destPath);

      if (replace) {
        $location.replace();
      }
    }
  }
})();
